import initialState from '../reducers/initialState';
import * as actionTypes from '../constants/actionTypes';

export default function addressReducer(state = initialState.address, action) {
  switch(action.type) {
    case actionTypes.ADDRESS_CHANGED:
      return { ...state, ...action.address };

    case actionTypes.ADDRESS_CLEAN:
      return { ...initialState.address };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/addressReducer.js